import { render } from "./index.vue?vue&type=template&id=06e1e62a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=06e1e62a&lang=css"
script.render = render

export default script